import React, { FC } from 'react';

export interface Props {
  value: string | undefined;
  textColor?: string;
}

const StaticTextField: FC<Props> = ({ value, textColor }: Props) => {
  return <div style={{ color: textColor }}>{value}</div>;
};

export default StaticTextField;
